enum PROVIDER_ID {
  YELP = 2,
  GLX = 3,
  GYG = 4,
}

export default PROVIDER_ID;
